import { useLocation } from "react-router";
import { Box } from "@mui/material";
import DigitalTwinHeader from "../components/digitalTwin/mainGrid/digitalTwinHeader.component";
import DigitalTwinNavbar from "../components/digitalTwin/mainGrid/digitalTwinNavbar.component";
import DigitalTwinSideMenu from "../components/digitalTwin/mainGrid/digitalTwinSideMenu.component";

export default function DigitalTwinLayout({ children }) {
  const location = useLocation();
  const pathname = location.pathname;
  // Adjust these checks based on your actual routes
  const isDashboard = pathname.startsWith("/digitalTwin");
  const isDetail = pathname.startsWith("/digitalTwin/");
  console.log("Current pathname:", pathname);

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
      }}
    >
      {isDashboard && <DigitalTwinSideMenu />}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          overflow: "hidden",
        }}
      >
        {isDashboard && <DigitalTwinHeader />}
        {isDetail && <DigitalTwinNavbar />}

        <Box
          sx={{
            flexGrow: 1,
            backgroundColor: "background.paper",
            minHeight: 0, // ensures flex child can shrink/grow properly
            overflowY: "auto",
            overflowX: "hidden",
            p: 1,
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}
